import { useQuery } from '@tanstack/react-query';
import { api } from '~/lib/api-client';
import { uiPreferencesKeys } from '~/lib/query-keys';

export interface UiPreferences {
  /** False ⇒ no hover hint opens anywhere in the app (FRONT-2267). */
  tooltipsEnabled: boolean;
  /** Id of the last "What's new" note this person closed (FRONT-2512). */
  dismissedReleaseNoteId: string | null;
}

/**
 * FRONT-2267: the person's UI switches, read once at boot.
 *
 * `retry: false` because this also mounts on the login screen, where it 401s
 * by design — a retry storm there buys nothing, and the caller falls back to
 * hints-on regardless.
 *
 * There is deliberately no attempt to beat first paint. A hover hint only
 * renders once someone has actually hovered a control, which is far longer
 * than this request takes, so the flicker a boot-time preference usually has
 * cannot happen here.
 */
export function useUiPreferences() {
  return useQuery({
    queryKey: uiPreferencesKeys.all,
    queryFn: () => api.get<UiPreferences>('/api/me/ui-preferences'),
    staleTime: 5 * 60_000,
    retry: false,
  });
}
